import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../resources/css/common.css";
import "../../resources/css/layout.css";
import ScrollAnimation from "../../resources/js/ScrollAnimation.js";
import Header from "../Header/Header.jsx";
import Footer from "../Footer/Footer.jsx";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Mousewheel } from "swiper/modules";
import "swiper/swiper-bundle.css";

const Presence = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [player, setPlayer] = useState(null);

  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    const titleElement = document.getElementsByTagName("title")[0];
    titleElement.innerHTML = `아소비 | 아소비 입회`;

    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = () => {
      const newPlayer = new window.YT.Player("u_player", {
        height: "560",
        width: "315",
        videoId: "oYLIXq4RQ_c",
      });
      setPlayer(newPlayer);
    };

    // 페이지 뷰 추적
    window.gtag("config", "G-LYT78YCDYK", {
      page_path: location.pathname,
    });

    // IP 체크 함수
    const checkIP = async () => {
      const response = await fetch("/check-ip");
      const result = await response.json();

      // 리다이렉션 확인
      if (result.redirect) {
        navigate(result.redirect); // navigate로 리다이렉션
      }
    };

    checkIP(); // IP 체크 함수 호출
  }, [location, navigate]); // navigate 추가

  const handlePlay = () => {
    if (player) {
      player.playVideo();
      setIsPlaying(true); // 비디오가 재생되면 상태 업데이트
    }
  };

  return (
    <div>
      <Header>
        <div className="header-down">
          <div className="wrap">
            <ul>
              <li>
                <a href="/presence" className="sel">
                  아소비 입회
                </a>
              </li>
              <li>
                <a href="/diagnostic">진단 테스트</a>
              </li>
              <li>
                <a href="/sptp">SPTP 종합심리검사</a>
              </li>
              <li>
                <a href="/branch">우리 동네 아소비</a>
              </li>
            </ul>
          </div>
        </div>
      </Header>
      <ScrollAnimation />
      <section id="container">
        <div className="presence">
          <div className="sect presence01">
            <div className="wrap">
              <div className="tit init">
                초등학교 가기 전에 한글 뗄 수 있을까요?
                <br />
                아이가 숫자, 한글을 자꾸 거꾸로 써요.
                <br />
                맞춤법 모르는 우리 아이, <br className="mo-view" />
                학교 과정 잘 따라 갈 수 있을까요?
              </div>
            </div>
          </div>
          <div className="sect presence02">
            <div className="wrap">
              <div className="tit init">
                <strong>아소비</strong>와 함께라면 <br />
                우리 아이 교육 <strong>고민 끝!</strong>
              </div>
              <div className="vod">
                <div
                  className="img"
                  id="play"
                  onClick={handlePlay}
                  style={isPlaying ? { opacity: 0, zIndex: 1 } : {}}
                >
                  <i></i>
                  <img src="../custom-resources/img/TVC_231011.png" alt="" />
                </div>
                <div className="iframe">
                  <div id="u_player"></div>
                </div>
              </div>
              <br />
              <div className="tit init">
                아소비가 TV에 떴다! <br className="mo-view" />
                <strong>아소비 NEW CF 영상</strong> 공개!
              </div>
              <div className="txt init">
                건강한 공부, 즐거운 공부, 행복한 공부
                <br />
                <br />
                듣기만 해도 신나는 아소비 댄스처럼 공부도 재미있게! <br />
                스스로 즐겁게 공부하는 힘, 아소비에서 경험해 보세요!
              </div>
            </div>
          </div>
          <div className="sect presence03">
            <div className="tit init">우리 아이 수준에 맞는 단계별 학습! </div>
            <div className="txt init">
              한글부터 수학, 칠교, 한자, 창의 교구 놀이까지{" "}
              <br className="mo-view" /> <p>다양한 수업</p>을 <br />
              아이 수준에 맞는
              <br className="mo-view" /> 단계별 학습으로{" "}
              <p>기초부터 탄탄하게!</p>
            </div>
            <div className="img">
              <img
                src="../custom-resources/img/img_presence_presence03.png"
                className="pc-view"
                alt=""
              />
              <img
                src="../custom-resources/img/img_presence_presence03_before.png"
                className="pc-view init"
                alt=""
              />
              <img
                src="../custom-resources/img/img_presence_presence03_mo.png"
                className="mo-view"
                alt=""
              />
              <img
                src="../custom-resources/img/img_presence_presence03_mo_before.png"
                className="mo-view init"
                alt=""
              />
            </div>
          </div>
          <div className="sect presence04">
            <div className="wrap">
              <div className="tit">아소비 프로그램 커리큘럼</div>
              <div className="slider">
                <Swiper
                  modules={[Autoplay, Navigation, Mousewheel]}
                  autoplay={{
                    delay: 4500,
                    disableOnInteraction: false,
                  }}
                  loop={true}
                  slidesPerView={1}
                  navigation={true}
                  mousewheel={true}
                >
                  <SwiperSlide className="sbox">
                    <div className="simg">
                      <img
                        src="../custom-resources/img/img_presence_presence04_img01.png"
                        alt=""
                      />
                    </div>
                    <div className="step yellow">STEP 01</div>
                    <div className="stit">베이직 과정</div>
                    <div className="stxt">
                      <strong>기초 개념을 다루는 가장 첫 단계</strong>
                      <span>
                        다양한 감각교구와 창의교구를 활용하여 <br />
                        쉽게 놀이하듯 체험하며 학습합니다.
                      </span>
                    </div>
                    <div className="sact">
                      <a href="/process_basic">자세히 보기</a>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="sbox swiper-slide">
                      <div className="simg">
                        <img
                          src="../custom-resources/img/img_presence_presence04_img02.png"
                          alt=""
                        />
                      </div>
                      <div className="step green">STEP 02</div>
                      <div className="stit">그로우 과정</div>
                      <div className="stxt">
                        <strong>
                          학습의 기본기를 <br className="mo-view" />
                          다지는 단계
                        </strong>
                        <span>
                          아소비만의 특화된 교수법으로 한글, 수학, 칠교,{" "}
                          <br className="mo-view" /> 한자 등{" "}
                          <br className="pc-view" />
                          학습의 기본 개념을 이해하고 <br className="mo-view" />
                          탄탄하게 다질 수 있습니다.
                        </span>
                      </div>
                      <div className="sact">
                        <a href="/process_grow">자세히 보기</a>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="sbox swiper-slide">
                      <div className="simg">
                        <img
                          src="../custom-resources/img/img_presence_presence04_img03.png"
                          alt=""
                        />
                      </div>
                      <div className="step pink">STEP 03</div>
                      <div className="stit">마스터 과정</div>
                      <div className="stxt">
                        <strong>
                          사고력과 창의력을 <br className="mo-view" />
                          키우는 단계
                        </strong>
                        <span>
                          유아 심화 과정으로 기본 개념을 응용하여{" "}
                          <br className="mo-view" />
                          확장시킬 수 있으며, <br className="pc-view" />
                          스스로 생각하는 힘과 <br className="mo-view" />
                          글과 그림으로 표현하는 힘을 기를 수 있습니다.
                        </span>
                      </div>
                      <div className="sact">
                        <a href="/process_master">자세히 보기</a>
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="sbox swiper-slide">
                      <div className="simg">
                        <img
                          src="../custom-resources/img/img_presence_presence04_img04.png"
                          alt=""
                        />
                      </div>
                      <div className="step blue">STEP 04</div>
                      <div className="stit">초등 과정</div>
                      <div className="stxt">
                        <strong>초등 교과 연계를 통한 심화 학습</strong>
                        <span>
                          학교 교과과정과 연계된 학습으로{" "}
                          <br className="mo-view" />
                          문제 해결 능력 높이기
                        </span>
                      </div>
                      <div className="sact">
                        <a href="/program_elementary1">자세히 보기</a>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
          <div className="sect presence05">
            <div className="txt init">
              기어 다니는 유치 과정과 뛰어다니는 초등 과정의{" "}
              <br className="mo-view" />
              중간 단계인 걷는 과정을 통해 <br />
              아이에게 탄탄한 브릿지 공부 방법을 알려주고{" "}
              <br className="mo-view" />
              평생 공부 습관의 힘을 길러 줍니다.{" "}
            </div>
            <div className="img">
              <img
                src="../custom-resources/img/img_presence_presence05.png"
                className="pc-view"
                alt=""
              />
              <img
                src="../custom-resources/img/img_presence_presence05_mo.png"
                className="mo-view"
                alt=""
              />
            </div>
          </div>
          <div className="sect presence06">
            <div className="wrap">
              <div className="tit init">믿을 수 있는 아소비</div>
              <div className="slider">
			  <Swiper
			    modules={[Mousewheel]}
			    mousewheel={true}
			    slidesPerView="auto"
			    spaceBetween={30}
			    breakpoints={{
			      320: {
			        slidesPerView: 2, // 레이아웃 2열
			        spaceBetween: 50,
			      },
			      1024: {
			        slidesPerView: "auto",
			      },
			    }}
			    onSlideChange={(swiper) => {
			      setTimeout(() => {
			        swiper.params.mousewheel.releaseOnEdges = false;
			      }, 500);
			    }}
			    onReachEnd={(swiper) => {
			      setTimeout(() => {
			        swiper.params.mousewheel.releaseOnEdges = true;
			      }, 750);
			    }}
			  >
                  <SwiperSlide>
                    <img
                      src="../custom-resources/img/img_presence_presence06_img01.png"
                      alt=""
                    />
                    <p>특허받은 한글 교재</p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="../custom-resources/img/img_presence_presence06_img02.png"
                      alt=""
                    />
                    <p>
                      (3년 연속)중소벤처기업부 <br />
                      우수프랜차이즈 1등급
                    </p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="../custom-resources/img/img_presence_presence06_img07.png"
                      alt=""
                    />
                    <p>
                      한국브랜드선호도 1위
                      <br />
                    </p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="../custom-resources/img/img_presence_presence06_img03.png"
                      alt=""
                    />
                    <p>
                      한국공정거래조정원
                      <br />
                      2021 착한프랜차이즈
                    </p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="../custom-resources/img/img_presence_presence06_img04.png"
                      alt=""
                    />
                    <p>명품브랜드 대상</p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="../custom-resources/img/img_presence_presence06_img05.png"
                      alt=""
                    />
                    <p>
                      2021 한국프랜차이즈 대상 <br />
                      산업통상자원부 표창
                    </p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="../custom-resources/img/img_presence_presence06_img06.png"
                      alt=""
                    />
                    <p>중소벤처기업부장관 표창 수상</p>
                  </SwiperSlide>
                </Swiper>
                {/* <div className="swiper-wrapper">
                  <SwiperSlide>
                    <img
                      src="../resources/img/img_presence_presence06_img01.png"
                      alt=""
                    />
                    <p>특허받은 한글 교재</p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="../resources/img/img_presence_presence06_img02.png"
                      alt=""
                    />
                    <p>
                      (3년 연속)중소벤처기업부 <br />
                      우수프랜차이즈 1등급
                    </p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="../resources/img/img_presence_presence06_img07.png"
                      alt=""
                    />
                    <p>
                      한국브랜드선호도 1위
                      <br />
                    </p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="../resources/img/img_presence_presence06_img03.png"
                      alt=""
                    />
                    <p>
                      한국공정거래조정원
                      <br />
                      2021 착한프랜차이즈
                    </p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="../resources/img/img_presence_presence06_img04.png"
                      alt=""
                    />
                    <p>명품브랜드 대상</p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="../resources/img/img_presence_presence06_img05.png"
                      alt=""
                    />
                    <p>
                      2021 한국프랜차이즈 대상 <br />
                      산업통상자원부 표창
                    </p>
                  </SwiperSlide>
                  <SwiperSlide>
                    <img
                      src="../resources/img/img_presence_presence06_img06.png"
                      alt=""
                    />
                    <p>중소벤처기업부장관 표창 수상</p>
                  </SwiperSlide>
                </div> */}
              </div>
            </div>
          </div>
          <div className="sect presence07">
            <div className="wrap">
              <div className="tit init">아소비 입회 안내</div>
              <div className="txt init">
                진단 테스트와 SPTP 종합심리검사를 통한{" "}
                <br className="mo-view" /> 우리 아이 맞춤형 교육{" "}
                <br className="pc-view" />
                똑똑한 아소비로 <br className="mo-view" />
                우리 아이 올바른 교육 준비를 지금 시작하세요!
              </div>
              <div className="lst init">
                <ul>
                  <li className="init">
                    <p>전화 상담</p>
                  </li>
                  <li className="init">
                    <p>대면 상담</p>
                  </li>
                  <li className="init">
                    <p>아소비 입회</p>
                  </li>
                  <li className="init">
                    <p>
                      <strong>진단 테스트</strong>
                    </p>
                    <a href="/diagnostic">자세히 보기</a>
                  </li>
                  <li className="init">
                    <p>교재 선정</p>
                  </li>
                  <li className="init">
                    <p>
                      <strong>
                        SPTP <br /> 종합심리검사{" "}
                      </strong>
                    </p>
                    <a href="/sptp">자세히 보기</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="sect presence08">
            <div className="wrap">
              <div className="img">
                <img
                  src="../custom-resources/img/img_presence_presence08.png"
                  alt=""
                />
              </div>
              <div className="tit init">
                모두가 알지만, 실천이 어려운 유기농공부
              </div>
              <div className="txt init">
                왜 우리 아이들은 배움을 행복하게 즐기지 못하는가에 대해 <br />
                끊임없이 질문하고 해답을 찾기 위해 노력해 온 아소비입니다.{" "}
                <br />
                지난 10여년간 아소비를 찾아주신 학부모의 입소문이 증명합니다.{" "}
                <br className="pc-view" />
                공부하는 습관을 잡아주는 유기농공부의 실천은 <br />
                오직 아소비만이 할 수 있습니다.{" "}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Presence;
